const ENV = "DEV";

export const ALL_API = {
  //DEV_API_HOST: "http://192.168.1.45:5002",
  // DEV_API_HOST: "http://182.77.59.45:5002",
  DEV_API_HOST: "https://api.doclift.ai",
  //DEV_API_HOST: "http://localhost:5002",
  //DEV_VOICE_API_HOST: "https://lk.doclift.ai",
  //DEV_VOICE_API_HOST: "http://localhost:5080"
};

export const CONFIG = {
  BASE_URL: ALL_API[ENV + "_API_HOST"],
  VOICE_URL: ALL_API[ENV + "_VOICE_API_HOST"],
};
export default CONFIG;

export const baseUrl = `${CONFIG.BASE_URL}`;
export const voiceBaseUrl = `${CONFIG.VOICE_URL}`;

export const GOOGE_CLIENT_ID = `742719906017-l83go7e4j1ipk6qana66aijsmmoclt8l.apps.googleusercontent.com`;
